export enum CoverStyle {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
}

export enum FontSize {
  Small = 'Small',
  Large = 'Large',
}

export enum FontColour {
  Light = 'Light',
  Dark = 'Dark',
}

export enum ColumnStyle {
  FullSize = 'Full_Width',
}
